<template>
  <div ref="charts" style="width:100%;height:600px"></div>
</template>
<script>
import echarts from "echarts";
import { onMounted, ref } from "vue";
import china from "echarts/map/json/china.json";
export default {
  name: "cMap",
  props: {
    echartsData: {
      type: Array
    },
    active:String
  },
  setup(props) {
    const charts = ref();
    onMounted(() => {
      const chart = charts.value;
      if (chart) {
        echarts.registerMap("china", china);
        var myChart = echarts.init(chart);
        var optionMap = {
          tooltip: {
            formatter: '{b}<br/>'+props.active+'：{c}',
          },
          legend: {
            orient: "horizontal",
          },
          visualMap: {
            min: 0,
            max: 1500,
            right: 0,
            orient: "horizontal",
            top: "bottom",
            text: ["高", "低"],
            calculable: true,
            color: [ "#214B78","#fff"],
          },
          selectedMode: "single",
          series: [
            {
              type: "map",
              mapType: "china",
              zoom:1.1,
              itemStyle: {
                normal: {
                  borderColor: "rgba(0, 0, 0, 0.2)",
                },
                emphasis: {
                  shadowOffsetX: 0,
                  shadowOffsetY: 0,
                  shadowBlur: 20,
                  borderWidth: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                },
              },
              showLegendSymbol: true,
              label: {
                normal: {
                  show: true,
                },
                emphasis: {
                  show: true,
                },
              },
              data: props.echartsData
            },
          ],
        };
        myChart.setOption(optionMap);
        window.addEventListener("resize", function () {
          myChart.resize();
        });
      }
      window.removeEventListener("resize", function () {
        myChart.resize();
      });
    });
    return {
      charts,
    };
  },
};
</script>